import { render, staticRenderFns } from "./bsTabs.vue?vue&type=template&id=2d0e3685&scoped=true&"
import script from "./bsTabs.vue?vue&type=script&lang=js&"
export * from "./bsTabs.vue?vue&type=script&lang=js&"
import style0 from "./bsTabs.vue?vue&type=style&index=0&id=2d0e3685&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e3685",
  null
  
)

export default component.exports